import axios from 'axios';

export const sendContactForm = async ({
  token,
  formName,
  data
}: {
  token: string;
  formName: string;
  data: any;
}): Promise<any> => {
  const URL = `${
    process.env.NEXT_PUBLIC_WP_API_URL || process.env.WP_API_URL
  }/v1/contact-forms/${formName}`;

  const config = {
    headers: {
      ['UYN-BEARER']: token
    }
  };

  return axios.post(URL, data, config);
};
